function SearchIndustrialPark() {
    const val = $(".input_button").val();
    if (!val) return;
    const url = new URL("/industry_statistic.html", location.origin)
    url.searchParams.append("IndustrialParkName", val)
    // const url = `./industry_statistic.html?`;
    window.location.href = url.href;
}

$(document).ready(() => {
    document.title = "列管污染源資料 (含裁處資訊) 查詢系統-依產業園區查詢"
    
    $(".search_btn").on("click", async function (e) {
        SearchIndustrialPark()
    })

    $(".input_block input").keyup(function (e) {
        if (e.keyCode === 13) {
            SearchIndustrialPark()
        }
    });
    // $(".dropdown >button").click(function (e) {
    //     e.stopPropagation();
    //     let show = $(".select_input_block .list_dropdown").css("display");
    //     if (show === "none") {
    //         $(".select_input_block .list_dropdown").fadeIn();
    //     } else {
    //         $(".select_input_block .list_dropdown").fadeOut();
    //     }
    // });
})